export let FieldIdentifier = /*#__PURE__*/function (FieldIdentifier) {
  FieldIdentifier["ADDRESS_LINE_1"] = "ADDRESS_LINE_1";
  FieldIdentifier["ADDRESS_LINE_2"] = "ADDRESS_LINE_2";
  FieldIdentifier["POSTAL_CODE"] = "POSTAL_CODE";
  FieldIdentifier["ADMINISTRATIVE_AREA"] = "ADMINISTRATIVE_AREA";
  FieldIdentifier["LOCALITY"] = "LOCALITY";
  return FieldIdentifier;
}({}); // CITY